import { IReportRequest } from "../../model/request/report/IReportRequest";
import { apiClient } from "../apiClient";
export const REPORT_ENDPOINT = "report";

export const reportApi = {
  SelectByPaging: (request: IReportRequest) =>
    apiClient.post(`${REPORT_ENDPOINT}/tong-hop`, request),
  ExportExcel: (request: IReportRequest) =>
    apiClient.post(`${REPORT_ENDPOINT}/export-excel`, request),
};
